import Breadcrumb from "../components/Breadcrumb";
import CarListingStatusLayer from "../components/child/CarListingStatusLayer"

const CarListingStatus = () => {
  return (
    <>
        {/* Breadcrumb */}
        <Breadcrumb title='All Car Listings' />

        {/* <AnnouncementLayer /> */}
        <CarListingStatusLayer />
    </>
  );
};

export default CarListingStatus;
